﻿export { ScheduleModule } from './schedule.module';
export { ScheduleComponent } from './schedule.component';